import { createStore } from 'vuex';
import packagingslip from './modules/packagingslip';
import frontendAppSettings from './modules/frontendAppSettings';

const defaultModules = {
  packagingslip,
  frontendAppSettings,
};

// eslint-disable-next-line no-unused-vars
async function hydrateInitialStoreValues(store) {
  // sample actions shown below to hydrate user information
  // await store.dispatch('user/getUser');
}

/** These actions are specific to local development. 
 * In production they would be accessed through the injected $hostStore.
 * All imports should have the same chunk name. */
async function getDevelopmentModules() {
  // const modulePromises = Promise.all([
  //   await (await import(/* webpackChunkName: "development-store" */ './modules/development/user')).default,
  // ]);

  // const [user] = await modulePromises;

  // return {
  //   user,
  // };
  return defaultModules;
}

async function createStoreForEnvironment() {
  const store = createStore({
    modules: {
      ...(process.env.NODE_ENV !== 'production') ? await getDevelopmentModules() : defaultModules,
    },
  });

  if (process.env.NODE_ENV !== 'production') {
    await hydrateInitialStoreValues(store);
  }

  return store;
}

export { createStoreForEnvironment };
